export default __webpack_public_path__ + "static/media/Recruit's Intellect.7652db52.jpg";